// TODO: move MAX_NESTING into constants
export const MAX_NESTING = 2
export const TEAM_LIBRARY = 'system'
export const PERSONAL_LIBRARY = 'library'
export const CUSTOM_CHANNEL = 'user'
export const PERSONAL_INBOX = 'inbox'
export const TEAM_INBOX = 'system_inbox'
export const CUSTOM_INBOX = 'custom_inbox'
export const BRIEF_INBOX = 'brief_inbox'
export const BRIEFS = 'briefs'
export const TERRITORY = 'territory'
export const SAVED_TO_DISCO = 'saved_to_disco'
export const LIBRARY_TYPES = [TEAM_LIBRARY, PERSONAL_LIBRARY]
export const INBOX_TYPES = [
  PERSONAL_INBOX,
  TEAM_INBOX,
  CUSTOM_INBOX,
  BRIEF_INBOX,
]
export const AUTO_TAGGING = 'is_auto_tagged'
export const NATIVE_TAG = 'native_tag'
export const MAX_CHANNELS_LIMITED_MODE = 3
export type GROUP_TYPE =
  | 'system'
  | 'library'
  | 'user'
  | 'inbox'
  | 'system_inbox'
  | 'custom_inbox'
  | 'brief_inbox'
  | 'territory'
  | 'is_auto_tagged'
  | 'native_tag'
  | 'saved_to_disco'
  | 'briefs'
export const INLINE_SEARCHABLE_GROUP_TYPES = [CUSTOM_CHANNEL]
